<style scoped  lang="less">
  @import 'detailsMatchEvent.less'; // 引入公共LESS文件
 
</style>
<style lang="less">
  .li_r{
    .i{color:  @color_2997FF;}
  }
  .li_l{
    .i{color:  @color_FF5D71;}
  }
</style>
<template>
  <div>
    <div class="data-loading" style="padding:20vh 0 50vh 0;"  v-if="isloginShow">
          <van-loading vertical><span class="loadtext">{{ langConfig.txtLang[langConfig.curLang]['LOADING'] }}</span></van-loading>
    </div>
    <div v-if="match&&eventList">  
      <template v-if="eventList&&eventList.length>0">
        <div class="eventListTypeBox">
          <div class="eventListType">
                <!-- <a href="javascript:void(0);"  @click="eventTypeNO_135(0)">111ALL</a> -->
                <a href="javascript:void(0);" :class="showLi==0?'on':''" @click="showLiTab(0)">{{ langConfig.details[langConfig.curLang]['TAB_EVENT']['ALL'] }}</a> 
                <a href="javascript:void(0);" :class="showLi==1?'on':''" @click="showLiTab(1)">{{ langConfig.details[langConfig.curLang]['TAB_EVENT']['GOALS'] }}</a> 
                <a href="javascript:void(0);" :class="showLi==2?'on':''" @click="showLiTab(2)">{{ langConfig.details[langConfig.curLang]['TAB_EVENT']['CORNERS'] }}</a> 
                <a href="javascript:void(0);" :class="showLi==3?'on':''" @click="showLiTab(3)">{{ langConfig.details[langConfig.curLang]['TAB_EVENT']['CARDS'] }}</a> 
          </div>
        </div>
        <!-- 1ST Half -->
        <div class="eventBox">
          <div class="listBox">
            <ul>
              <template v-for="(item, index) in eventList">
                <!-- :class="(item.team&&teamData[item.team].type=='away')?'li_r':'li_l'"  -->
                <li :class="getTeamType(item)" :key="index" v-if="htmlShow(item,2)&&isShowLi(item)">
                
                  <div class="liBox"> 
                    <!-- b- in on -->
                    <div class="l_state">
                      <template> 
                        <b v-if="item.matchState"
                         :class="
                         (htmlShow(item,1)?((item.eventType*1==9||item.eventType*1==137)?'in':''):'on')+' '+
                         ([1,3,4,24,41,115,116,134,135,136,].indexOf(item.eventType*1)>-1?'b_status':'')
                         "
                        >{{item.matchState}}</b>
                        <b class="web_s" v-else :class="!item.eventType?'b_statistics':'b_status'"></b>
                      </template>
                      <template> 
                        <s v-if="htmlShow(item,1)||!item.eventType" 
                        :class="(!item.eventType?'web_n ':'')"
                        >
                          <img :src="require(`@/assets/images/details/event/${item.eventType?item.eventType:0}.svg`)" /> 
                        </s>   
                        <s v-else class="web_n">
                          <img :src="require(`@/assets/images/details/event/status.svg`)" /> 
                        </s>     
                      </template>
                      <strong class="st_1" v-if="htmlShow(item,1)">{{langConfig.details[langConfig.curLang]['EVENT'][item.eventType?item.eventType:0].name}}</strong>
                      <i class="st_2" v-if="item.eventType==9||item.eventType==137">{{item.score?item.score:''}}</i>
                    </div>
                    <p :class="htmlShow(item,1)&&item.eventType?'':'on'">
                      <span v-html="getContent(item)"></span>
                    </p>
                  </div>
                  <div class="title"
                   v-if="(item.eventType*1==1||item.eventType*1==9999||item.eventType*1==4||item.eventType*1==135)&&((item.eventType*1==1&& eventList[(index*1+1)>(eventList.length-1)?(index*1+1):eventList.length-1].eventType==9999)?false:true)"
                   >
                    {{langConfig.details[langConfig.curLang]['EVENT'][(item.eventType==9999?1:item.eventType)].title}}
                  </div> 

                  <div class="title"
                   v-if="eventTypeNO_135(index)"
                   >
                    {{langConfig.details[langConfig.curLang]['EVENT'][135].title}}
                  </div>
                  
                </li>
              </template>
              <li class="li_l" v-if="false">
                <div class="title">
                  1ST Half
                </div> 
                <div class="liBox"> 
                  <!-- b- in on -->
                  <b>Kick-off</b>
                  <strong class="st_1">Yellow card</strong>
                  <i class="st_2">1:1</i>
                  <p class="on">
                    <span>
                      The referee whistled, and (<i>Manchester City)</i> were awarded a corner. 
                    </span>
                    <span>
                      Corner number x (Corners 2:3).
                    </span>
                    <s>
                      <img src="~@/assets/images/details/event/9.svg" />
                    </s>
                  </p>
                </div>
              </li>
              <li class="li_r" v-if="false">
                <div class="liBox"> 
                  <b>Kick-off</b>
                  <strong class="st_1">Yellow card</strong>
                  <i class="st_2">1:1</i>
                  <p class="on">
                    <span>
                      The referee whistled, and (<i>Manchester City)</i> were awarded a corner. 
                    </span>
                    <span>
                      Corner number x (Corners 2:3).
                    </span>
                    <s>
                      <img src="~@/assets/images/details/event/9.svg" />
                    </s>
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div> 
        <!-- 2ND Half -->
        <div class="eventBox" v-if="false">
          <div class="title">
            2ND Half
          </div> 
          <div class="listBox">
            <ul>
              <li class="li_l">
                <div class="liBox"> 
                  <!-- b- in on -->
                  <b>Kick-off</b>
                  <strong class="st_1">Yellow card</strong>
                  <i class="st_2">1:1</i>
                  <p class="on">
                    <span>
                      The referee whistled, and (<i>Manchester City)</i> were awarded a corner. 
                    </span>
                    <span>
                      Corner number x (Corners 2:3).
                    </span>
                    <s>
                      <img src="~@/assets/images/details/event/9.svg" />
                    </s>
                  </p>
                </div>
              </li>
              <li class="li_r">
                <div class="liBox"> 
                  <b>Kick-off</b>
                  <strong class="st_1">Yellow card</strong>
                  <i class="st_2">1:1</i>
                  <p class="on">
                    <span>
                      The referee whistled, and (<i>Manchester City)</i> were awarded a corner. 
                    </span>
                    <span>
                      Corner number x (Corners 2:3).
                    </span>
                    <s>
                      <img src="~@/assets/images/details/event/9.svg" />
                    </s>
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div> 
        <!-- Extra Time -->
        <div class="eventBox" v-if="false">
          <div class="title">
            Extra Time
          </div> 
          <div class="listBox">
            <ul>
              <li class="li_l">
                <div class="liBox"> 
                  <!-- b- in on -->
                  <b class="b_status">Kick-off</b>
                  <p class="on">
                    <span>
                      The referee whistled, and (<i>Manchester City)</i> were awarded a corner. 
                    </span>
                    <span>
                      Corner number x (Corners 2:3).
                    </span>
                    <s>
                      <img src="~@/assets/images/details/event/9.svg" />
                    </s>
                  </p>
                </div>
              </li>
              <li class="li_r">
                <div class="liBox"> 
                  <b class="b_statistics">Kick-off</b>
                  <p class="on">
                    <span>
                      The referee whistled, and (<i>Manchester City)</i> were awarded a corner. 
                    </span>
                    <span>
                      Corner number x (Corners 2:3).
                    </span>
                    <s>
                      <img src="~@/assets/images/details/event/9.svg" />
                    </s>
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div> 
        <!-- 标注 -->
        <div class="labelBox labelBox_r">
          <p class="p_web">
            <img src="~@/assets/images/details/event/home.png" />
            {{ langConfig.details[langConfig.curLang]['LABEL_TIPS']['HOME'] }}
          </p>
          <p class="p_web">
            <img src="~@/assets/images/details/event/away.png" />
            {{ langConfig.details[langConfig.curLang]['LABEL_TIPS']['AWAY'] }}
          </p>
          <p>
            <img src="~@/assets/images/details/event/9.svg" />
            {{ langConfig.details[langConfig.curLang]['LABEL_TIPS']['GOALS_SCORED'] }}
          </p>
          <p>
            <img src="~@/assets/images/details/event/137.svg" />
            {{ langConfig.details[langConfig.curLang]['LABEL_TIPS']['PENALTY'] }}
          </p>
          <p>
            <img src="~@/assets/images/details/event/138.svg" />
            {{ langConfig.details[langConfig.curLang]['LABEL_TIPS']['PENALTY_MISSED'] }}
          </p>
          <p>
            <img src="~@/assets/images/details/event/30.svg" />
            {{ langConfig.details[langConfig.curLang]['LABEL_TIPS']['CORNER'] }}
          </p> 
          <p>
            <img src="~@/assets/images/details/event/34.svg" />
            {{ langConfig.details[langConfig.curLang]['LABEL_TIPS']['INJURIES'] }}
          </p>
          <p>
            <img src="~@/assets/images/details/event/23.svg" />
            {{ langConfig.details[langConfig.curLang]['LABEL_TIPS']['SUBSITUTIONS'] }}
          </p>
          <p>
            <img src="~@/assets/images/details/event/status.svg" />
            {{ langConfig.details[langConfig.curLang]['LABEL_TIPS']['STATE'] }}
          </p>
          <p>
            <img src="~@/assets/images/details/event/26.svg" />
            {{ langConfig.details[langConfig.curLang]['LABEL_TIPS']['FREE_KICKS'] }}
          </p>
          <p>
            <img src="~@/assets/images/details/event/32.svg" />
            {{ langConfig.details[langConfig.curLang]['LABEL_TIPS']['SHOT_MISSED'] }} 
          </p>
          <p>
            <img src="~@/assets/images/details/event/31.svg" />
            {{ langConfig.details[langConfig.curLang]['LABEL_TIPS']['OFF_TARGET'] }}  
          </p>
          <p>
            <img src="~@/assets/images/details/event/18.svg" />
            {{ langConfig.details[langConfig.curLang]['LABEL_TIPS']['YELLOW_CARDS'] }}
          </p>
          <p>
            <img src="~@/assets/images/details/event/22.svg" />
            {{ langConfig.details[langConfig.curLang]['LABEL_TIPS']['RED_CARDS'] }}
          </p>
          <p>
            <img src="~@/assets/images/details/event/statistics.svg" />
            {{ langConfig.details[langConfig.curLang]['LABEL_TIPS']['STATISTIC'] }}
          </p>
        </div> 
      </template>

      <div class="no-data" v-else>
          <img :src="require(`@/assets/images/icon-nodata.png`)" alt="" />
          <span>{{ langConfig.txtLang[langConfig.curLang]['NO_DATA'] }}</span>
      </div>
    </div>
    
  </div>
</template>

<script>
import { getMatchEventLive } from '@/api/api';
export default {
  components: {
      
  },
  data() {
    return {
      isReadTime:0,
      isloginShow:true,
      baseParam:{ 
          userToken: '',
      },
      eventList:null,
      teamData:{
        
      },
      showLi:0
    };
  },
  methods: { 
    logdingFlag(){
      if(typeof(window) != 'undefined' && this.isloginShow){
        return true;
      }
      return false;
    },
    isHome(){
      return false;
    },
    eventTypeNO_135(_index){

      var eventList=JSON.parse(JSON.stringify(this.eventList||[]));
      var is135=(eventList.findIndex(item => item.eventType == 135)>-1)?true:false;
      //console.log('eventList',eventList);
      //console.log('is135',is135);
      var index_90=null;
      if(!is135){
        eventList.reduceRight((acc, item, index) => {
          //console.log('acc',acc);
            //console.log('item222',item);
            if(item.matchState){
              let A = item.matchState;
              let regex = /\d+/;
              //console.log('itemA',A);
              let match1 = A.match(regex);
              let result = match1 ? parseInt(match1[0], 10) : 0;

              //console.log('item',A,match1,result,result>90);
              if (result>90&&index_90===null) {
                  index_90=index;
              }
            }
           
        }, []);
      }
      //console.log('index_90',index_90);
      if(index_90!=null&&_index==index_90){
        return true;
      }
      return false;
    },
    isShowLi(item){
      var showLi=JSON.parse(JSON.stringify(this.showLi));
      if(showLi==0){return true;}
      if(showLi==1){return (item.eventType==9||item.eventType==135)?true:false;}
      if(showLi==2){return  (item.eventType==30)?true:false;}
      if(showLi==3){return  (item.eventType==22||item.eventType==21||item.eventType==18)?true:false;}
    },
    showLiTab(val){
      this.showLi=val;
    },
    htmlShow(item,type){
      if(type==1){//有事件的图标
        if(!item.eventType){
          if(item.content){
            item.eventType=0;
          }else{
            return false;
          }
        }
        return[9,18,21,22,23,26,30,31,32,34,40,137,138].indexOf(item.eventType*1)>-1
      }
      if(type==2){//直接过滤事件，无效
        return ([156,157,158,159,160,161,162].indexOf(item.eventType*1)>-1?false:true)
      }
        // 0：统计事件 1：比赛开始 3：比赛结束 4：下半场开始 8：获取点球
        // 9：进球 18：黄牌 21：黄红牌 22：红牌 23：替补
        // 24：伤停补时显示 26：任意球 30：角球 31：射正不进 32：射偏
        // 34：受伤 40：点球射失 41：点球决胜开始 115：加时赛上半场结束 116：加时赛结束
        // 134：上半场结束 135：加时上半场开始 136：加时下半场开始 137：点球进球 138：点球射失
        // 156：进球确认(VAR视频裁判事件，0取消进球 1确认进球) 157：罚牌升级确认(VAR视频裁判事件，0不升级 1升级)
        // 158：未进球确认(VAR视频裁判事件，0进球 1未进球) 159：点球确认(VAR视频裁判事件，0点球取消 1确认点球)
        // 160：红牌确认(VAR视频裁判事件，0红牌取消 1确认红牌) 161：不判罚点球确认(VAR视频裁判事件，0判罚点球 1不判罚点球)
        // 162：犯规球员确认(VAR视频裁判事件，0没有犯规 1判罚犯规) 9999：球馆信息
    },
    //主客队
    getTeamType(item){
      var teamData=JSON.parse(JSON.stringify(this.teamData));
      item=JSON.parse(JSON.stringify(item));
      if(!item.team.id){
        return 'li_l'
      }
      if(item.team.id<1){
        return 'li_l'
      }
      if(teamData[item.team.id].type=='away'){
        return 'li_r'
      }else{
        return 'li_l'
      }
      return 'li_l'
    },
    //内容处理
    getContent(item){
      let teamData=JSON.parse(JSON.stringify(this.teamData));
      let content=item.content;
      if(!item.team.id){return content;}
      let teamID=item.team.id;
      let name=teamData[teamID].fullName;
      function Substring(input, substring) {
        
        let regex = new RegExp(substring, 'gi');
        return input.replace(regex, '<i class="i">$&</i>');
      }
      if(name&&content){
        return  Substring(content, name);
      }else{
        return  content;
      }
    },
    //数据读取
    async getMatchEventLiveData(){
      
        let obj={
          matchId:this.matchId,
        }
        var _this=this;
        let param = Object.assign(obj, this.baseParam);
        //console.log('getMatchEventLive_param',param);
        await getMatchEventLive(param).then((res) => {
          this.isloginShow=false;
          //console.log('getMatchEventLive_res',res);
          let data=JSON.parse(JSON.stringify(res.data));
          //console.log('getMatchEventLive_data',data);
          _this.eventList=(data.eventList||[]).slice().reverse();
        }).catch((res) => {
          console.error(res)
        })
    },
    init(){
      var match=JSON.parse(JSON.stringify(this.match));
      if(match){
        this.watchMatch(match);  
      }
      if(!this.matchId){
        return;
      } 
      this.getMatchEventLiveData();
    },
    watchMatch(val){
      if(!val){
        return ;
      }
      var awayTeamID=val.awayTeam.id;
      var homeTeamID=val.homeTeam.id;
      var teamData={}
      teamData[awayTeamID]={
          type:'away',
          ...val.awayTeam,
      }
      teamData[homeTeamID]={
          type:'home',
          ...val.homeTeam,
      }
      //console.log('teamData1111',teamData);
      this.teamData=teamData;
    }
   
    
  },
  created() {
    
    this.isReadTime=this.isRead;
    this.init();
  
  },
  watch: {
    isRead(val){
      if(val!=this.isReadTime){
        this.init();
        this.isReadTime=val;
        console.log('MatchEvent-数据重置');
      }
    },
    match(val){
      this.watchMatch(val);
    },
    socketEventList(val){
      var list=val||[];
      if(list.length>0){
        //console.log('xxx',list);
        this.eventList=list.slice().reverse();
      }
    },
  },
  mounted() {
    
  },
  beforeDestroy() {
   
  },
  props: {
    match: {
      type: Object,
      default:null
    }, 
    matchId: {
      type: Number,
      default:null
    },
    socketEventList:{
      type:Array,
      default:() =>[],
    },
    isRead: {
      type: Number,
      default: 0,
    },
  },
};
</script>



// WEBPACK FOOTER //
// ./src/views/details/components/detailsMatchEvent.vue